import React, { useState, useEffect } from "react";
import { Button, Form } from "react-bootstrap";
import { CardBody } from "reactstrap";
import { renderElement } from "../../../Components/Common/FormRendererV2/Renderer";
import {
  CrossIcon,
  DownloadIcon,
  EditListIcon,
} from "../../../assets/images/svg/svg";
import PropTypes from "prop-types";
import { downloadFileFromURL } from "../../../Utils/CommonUtils";

const DocumentUploader = ({
  documentLayout,
  documentFields,
  files = {},
  formState,
  onUpload,
  onDownload,
  entityid,
  editMode = false,
  isEditing, // Passed from the parent component
  toggleEdit,
  showUploadButtonByDefault = false, // Passed from the parent component
}) => {
  const [showUploadButton, setShowUploadButton] = useState(
    showUploadButtonByDefault
  );

  const findMatchingFileByFieldLabel = (fieldLabel) =>
    files[fieldLabel] || null;

  const renderFileInput = (fieldKey) => {
    const field = documentFields[fieldKey];
    if (!field) {
      console.error(`Field not found for key: ${fieldKey}`);
      return null;
    }

    const file = findMatchingFileByFieldLabel(field["database-label"]);

    if (file && !isEditing[fieldKey]) {
      return (
        <div className="document-wrapper">
          <Form.Group>
            <Form.Label className="document-label">
              {field["display-fieldlabel"]}
            </Form.Label>
            <div className="d-flex justify-content-between align-items-center">
              <p>{file.filename}</p>
              <div className="documents-button-wrapper">
                <Button
                  variant="outline-secondary"
                  // onClick={() => onDownload(file.entityid, file.filename)}
                  onClick={() =>
                    downloadFileFromURL(file.media_url, file.filename)
                  }
                  className="me-2"
                >
                  <DownloadIcon />
                </Button>
                <Button
                  variant="outline-secondary"
                  onClick={() => toggleEdit(fieldKey)}
                >
                  <EditListIcon />
                </Button>
              </div>
            </div>
          </Form.Group>
        </div>
      );
    }

    return (
      <Form.Group className="documents">
        <div className="d-flex align-items-center">
          <div className="flex-grow-1">
            {renderElement(field, documentFields, formState)}
          </div>
          {isEditing[fieldKey] && (
            <span
              className="cancel ms-2"
              onClick={() => toggleEdit(fieldKey)}
              style={{ cursor: "pointer" }}
            >
              <CrossIcon />
            </span>
          )}
        </div>
      </Form.Group>
    );
  };

  const shouldEnableUploadButton = () => {
    if (Object.keys(files).length === 0) return true;
    return Object.keys(documentFields).some((key) => {
      const file = findMatchingFileByFieldLabel(
        documentFields[key]["database-label"]
      );
      const isEditingMode = isEditing[key];

      return !file || isEditingMode;
    });
  };

  return (
    <Form>
      <CardBody>
        {documentLayout?.map((element) => (
          <div key={element?.elementid}>
            {element?.child?.map((child) => {
              const fieldKey = `${child?.elementid}-${child?.elementtype}`;
              return <div key={fieldKey}>{renderFileInput(fieldKey)}</div>;
            })}
          </div>
        ))}
      </CardBody>
      {editMode && showUploadButton && (
        <div className="d-flex justify-content-end mt-3">
          <Button
            type="button"
            className="btn btn-secondary"
            onClick={onUpload}
            disabled={!shouldEnableUploadButton()}
          >
            Upload
          </Button>
        </div>
      )}
    </Form>
  );
};

export default DocumentUploader;
